import React from 'react';
import PropTypes from 'prop-types';

function Photo(props) {
  const ratio = 19 / 26;

  return (
    <svg width={props.size} height={Math.floor(props.size * ratio)} viewBox="0 0 26 19">
      <g stroke="#fff" fill="none" fillRule="evenodd">
        <path d="M.5 14.77V4.403A2.913 2.913 0 0 1 3.403 1.5h19.115a2.913 2.913 0 0 1 2.903 2.904V14.77a2.912 2.912 0 0 1-2.902 2.902H3.403A2.912 2.912 0 0 1 .5 14.77z" />
        <path d="M17.682 9.586a4.72 4.72 0 1 1-9.443 0 4.72 4.72 0 0 1 9.442 0zm4.412-4.26a.462.462 0 1 1-.924 0 .462.462 0 0 1 .924 0z" />
      </g>
    </svg>
  );
}

Photo.defaultProps = {
  size: 26,
};

Photo.propTypes = {
  size: PropTypes.number,
};

export default Photo;
